import PermissionRolesDialog from './PermissionRolesDialog';

export default PermissionRolesDialog;